import { AspectRatio, Text, Box } from "@chakra-ui/react";

export const HelpModalBody = ({ url }: { url: string }) => {
  return (
    <Box>
      <Text>Need assistance? Visit our Help Center for tutorials, tips, and all the support you require.</Text>
      <Box mt={8} mb={4}>
        <Text>Whats New?</Text>
      </Box>
      <AspectRatio ratio={16 / 9}>
        <iframe title="Artesian Tutorial" src={url} allowFullScreen />
      </AspectRatio>
    </Box>
  );
};
